export default function convertInchesToFeet(inches) {
    return inches / 12;
}